export default "__VITE_ASSET__12f495b3__"